<template>
  <v-dialog
    v-if="$store.state.auth.checkAccess({key: 'manual_transaction', value: ['balance', 'refund', 'bonus', 'sport_bonus', 'freespins', 'bonus_template', 'respin']})"
    v-model="$store.state.manual_transaction.dialog"
    :width="max([$store.state.auth.user.permission.manual_transaction.length * 100, 550])"
  >
    <v-card>

      <v-tabs
        v-model="bonusTypeModel"
        class="mt-tab-menu"
        centered
      >
        <v-tabs-slider></v-tabs-slider>

        <v-tab
          v-for="tab in availableTabs"
          :key="tab.key"
          :href="`#${tab.href}`"
          v-if="bonusTypeModel === tab.href || $store.state.manual_transaction.isVisibleTab"
          class="mt-tab-item"
        >
          {{ tab.label }}
        </v-tab>

      </v-tabs>
      <v-card-text>

        <v-tabs-items touchless v-model="bonusTypeModel">
          <v-tab-item
            v-if="$store.state.auth.checkAccess({key: 'manual_transaction', value: 'balance'})"
            id="mt-balance"
          >
            <v-form
              ref="mt-form-balance"
              v-model="balance.valid"
              class="mt-4"
            >
              <v-select
                label="Type"
                v-model="balance.form.type"
                :items="balanceTypeOptions">
              </v-select>
              <v-combobox
                label="Name"
                v-model="balance.form.name"
                :loading="balance.isLoadingManualTransactionOptions"
                :rules="[v => !!v || 'Name is required']"
                :items="balance.name?.[balance.form.type] || []"
              />

              <v-text-field
                required
                label="Amount"
                :type="['xs', 'sm', 'md'].includes($vuetify.breakpoint.name) ? 'text' : 'number'"
                hide-details
                :rules="[v => !!v || 'Amount is required']"
                v-model="balance.form.amount"
                :suffix="account.currency || ''"
                :prefix="balance.form.amount ? (balance.form.amount < 0 ? 'Withdraw: ' : 'Deposit: ') : ''"
                placeholder="Amount > 0 - Deposit, Amount < 0 - Withdraw"
              ></v-text-field>
            </v-form>
          </v-tab-item>
          <v-tab-item
            v-if="$store.state.auth.checkAccess({key: 'manual_transaction', value: 'refund'})"
            id="mt-refund"
          >
            <v-form
              ref="mt-form-refund"
              v-model="refund.valid"
              class="mt-4"
            >
              <v-select
                label="Type"
                v-model="refund.form.paymethod"
                :items="refund.paymethod">
              </v-select>

              <v-text-field
                required
                label="Account"
                v-model="refund.form.account"
              ></v-text-field>

              <v-text-field
                required
                label="Amount"
                type="number"
                hide-details
                :rules="[v => !!v || 'Amount is required']"
                v-model="refund.form.amount"
                :suffix="account.currency || ''"
              ></v-text-field>
            </v-form>
          </v-tab-item>
          <v-tab-item
            v-if="$store.state.auth.checkAccess({key: 'manual_transaction', value: 'respin'})"
            id="mt-respin"
          >
            <v-form
              ref="mt-form-respin"
              v-model="respin.valid"
              class="mt-4"
            >
              <v-row justify="center">
                <v-select
                  label="Type"
                  :items="respin.type_list"
                  v-model="respin.form.types"
                  :rules="[v => !!v || 'Type is required']"
                  multiple
                  class="col-6"
                >
                  <template v-slot:selection="{ item: chipItem, index }">
                    <div style="max-width: 180px" class="v-select__selection v-select__selection--comma"
                         v-if="index < respin.chipCount">
                      {{ chipItem.text || chipItem }}{{ index < respin.chipCount - 1 ? ',' : '' }} &nbsp;
                    </div>
                    <span
                      class="caption float-right"
                      v-if="index === respin.chipCount && (respin.types || []).length > respin.chipCount"
                    >(+{{ (respin.types || []).length - respin.chipCount }} others)</span>
                  </template>
                </v-select>

                <v-select
                  :loading="respin.benefitListLoading"
                  label="Benefit"
                  :items="respin.benefit_list"
                  v-model="respin.form.benefit_id"
                  :rules="[v => !!v || 'Benefit is required']"
                  class="col-6"
                >
                </v-select>
              </v-row>

              <v-row justify="center">
                <v-select
                  label="Status"
                  :rules="[v => !!v || 'Status is required']"
                  v-model="respin.form.status"
                  :items="respin.statuses"
                  class="col-3 pb-1"
                />
                <date-picker
                  v-model="respin.form.expireDate"
                  label="Expire"
                  class="col-6 pa-0 px-3"
                  :show-time="true"
                  :time-value="respin.form.expireTime"
                  :check-validation="true"
                  @time-change="handleExpireTimeChange('respin', $event)"
                />
                <v-text-field
                  required
                  label="Amount"
                  type="number"
                  :rules="[v => !!v && v !== '0' || 'Amount is required']"
                  v-model="respin.form.amount"
                  hide-details
                  class="col-3"
                ></v-text-field>
              </v-row>

              <v-divider class="mt-2" />

              <v-row class="px-0 mx-0 flex-wrap">
                <v-col cols="12" class="px-0">
                  <v-label>
                    Additional Requirements
                  </v-label>
                  <v-btn-toggle
                    v-model="respin.form.additional_requirements"
                    class="mt-1"
                    multiple
                    borderless
                  >
                    <v-btn
                      v-for="(label, key) in additionalRequirementOptions"
                      :key="key"
                      :value="key"
                      small
                      v-text="label"
                    />
                  </v-btn-toggle>
                </v-col>
              </v-row>
            </v-form>
          </v-tab-item>
          <v-tab-item
            v-if="$store.state.auth.checkAccess({key: 'manual_transaction', value: 'bonus'})"
            id="mt-bonus"
          >
            <v-form
              ref="mt-form-bonus"
              v-model="bonus.valid"
              class="mt-4"
            >
              <v-row justify="center" class="px-0 mx-0">
                <v-combobox
                  label="Bonus Name"
                  :rules="[v => !!v || 'Bonus Name is required']"
                  v-model="bonus.form.name"
                  :items="bonus.name[account.language || 'EN'] || bonus.name['EN']">
                </v-combobox>

                <v-select
                  label="Rollover Type"
                  class="col-3"
                  :rules="[v => !!v || 'Rollover Type is required']"
                  v-model="bonus.form.rollover_type"
                  :items="bonus.rollover_type">
                </v-select>

                <v-checkbox
                  label="Sticky bonus"
                  v-model="bonus.form.sticky"
                  hide-details
                  :true-value="1"
                  :false-value="0"
                  class="ml-3 mt-0 pt-5"
                />
              </v-row>

              <v-row justify="center">
                <v-text-field
                  required
                  label="Wager"
                  type="number"
                  class="col-2 pb-1"
                  :rules="[v => !!v || 'Wager is required']"
                  v-model="bonus.form.wager"
                />

                <v-select
                  label="Status"
                  :rules="[v => !!v || 'Status is required']"
                  v-model="bonus.form.status"
                  :items="bonus.statuses"
                  class="col-3 pb-1"
                />

                <date-picker
                  v-model="bonus.form.expireDate"
                  label="Expire"
                  class="col-6 pa-0 px-3"
                  :show-time="true"
                  :time-value="bonus.form.expireTime"
                  :check-validation="true"
                  @time-change="handleExpireTimeChange('bonus', $event)"
                />
              </v-row>
              <v-row>
                <v-text-field
                  required
                  label="Deposit Amount %"
                  type="number"
                  v-model="bonus.form.deposit_amount_percent"
                  hide-details
                  class="col-4"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-text-field
                  required
                  label="Max Release"
                  type="number"
                  v-model="bonus.form.max_release"
                  hide-details
                  class="col-4"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-text-field
                  required
                  label="Amount"
                  type="number"
                  :rules="[v => !!v && v !== '0' || 'Amount is required']"
                  v-model="bonus.form.amount"
                  :suffix="account.currency || ''"
                  hide-details
                  class="col-4"
                ></v-text-field>
              </v-row>

              <v-row justify="center">
                <v-text-field
                  required
                  label="Bet Limits: Min"
                  type="number"
                  class="col-3"
                  v-model="bonus.form.bet_limits_min"
                  hide-details
                />

                <v-text-field
                  required
                  label="Bet Limits: Max"
                  type="number"
                  class="col-3"
                  v-model="bonus.form.bet_limits_max"
                  hide-details
                />

              </v-row>

              <v-divider class="mt-2" />

              <v-row class="px-0 mx-0 flex-wrap">
                <v-col cols="12" class="px-0">
                  <v-label>
                    Additional Requirements
                  </v-label>
                  <v-btn-toggle
                    v-model="bonus.form.additional_requirements"
                    class="mt-1"
                    multiple
                    borderless
                  >
                    <v-btn
                      v-for="(label, key) in additionalRequirementOptions"
                      :key="key"
                      :value="key"
                      small
                      v-text="label"
                    />
                  </v-btn-toggle>
                </v-col>
              </v-row>

              <v-divider class="mb-3 mt-2" />

              <v-row justify="center" class="px-0 mx-0">
                <v-combobox
                  multiple
                  auto-select-first
                  label="Brands (filter)"
                  class="col-6 pl-0"
                  hide-details
                  @input="bonusClearBrandFilter"
                  :search-input.sync="bonus.brandsFilterInput"
                  v-model="bonus.brandsFilter"
                  :items="bonus.brands"
                />
                <v-autocomplete
                  label="Exclusive for Game"
                  item-text="name"
                  item-value="game_id"
                  hide-details
                  clearable
                  v-model="bonus.form.game_id_exclusive"
                  :items="filteredBonusGames"
                />
              </v-row>
              <v-row justify="center" class="px-0 mx-0">
                <v-autocomplete
                  label="Exclusive for Brand"
                  hide-details
                  clearable
                  class="col-6 pl-0"
                  v-model="bonus.form.brand_exclusive"
                  :items="providerBrandsAliases"
                />
                <v-autocomplete
                  label="Exclusive for System"
                  hide-details
                  clearable
                  class="col-6 pr-0"
                  v-model="bonus.form.system_exclusive"
                  :items="providerSystemsAliases"
                />
              </v-row>
            </v-form>
          </v-tab-item>
          <v-tab-item
            v-if="$store.state.auth.checkAccess({key: 'manual_transaction', value: 'overdraft'})"
            id="mt-overdraft"
          >
            <v-form
              ref="mt-form-overdraft"
              v-model="overdraft.valid"
              class="mt-4"
            >
              <v-combobox
                label="Bonus Name"
                :rules="[v => !!v || 'Bonus Name is required']"
                v-model="overdraft.form.name"
                :items="overdraft.name[account.language || 'EN'] || overdraft.name['EN'] || []">
              </v-combobox>

              <v-row justify="center">
                <v-select
                  label="Status"
                  :rules="[v => !!v || 'Status is required']"
                  v-model="overdraft.form.status"
                  :items="overdraft.statuses"
                  class="col-3 pb-1"
                ></v-select>

                <date-picker
                  v-model="overdraft.form.expireDate"
                  label="Expire"
                  class="col-6 pa-0 px-3"
                  :show-time="true"
                  :time-value="overdraft.form.expireTime"
                  :check-validation="true"
                  @time-change="handleExpireTimeChange('overdraft', $event)"
                />

                <v-text-field
                  required
                  label="Amount"
                  type="number"
                  :rules="[v => !!v || 'Amount is required']"
                  v-model="overdraft.form.amount"
                  :suffix="account.currency || ''"
                  hide-details
                  class="col-3"
                ></v-text-field>
              </v-row>

              <v-divider class="mt-2" />

              <v-row class="px-0 mx-0 flex-wrap">
                <v-col cols="12" class="px-0">
                  <v-label>
                    Additional Requirements
                  </v-label>
                  <v-btn-toggle
                    v-model="overdraft.form.additional_requirements"
                    class="mt-1"
                    multiple
                    borderless
                  >
                    <v-btn
                      v-for="(label, key) in additionalRequirementOptions"
                      :key="key"
                      :value="key"
                      small
                      v-text="label"
                    />
                  </v-btn-toggle>
                </v-col>
              </v-row>

              <v-divider class="mb-3 mt-2" />

              <v-row justify="center" class="px-0 mx-0">
                <v-combobox
                  multiple
                  auto-select-first
                  label="Brands (filter)"
                  class="col-6 pl-0"
                  hide-details
                  @input="bonusClearBrandFilter"
                  :search-input.sync="overdraft.brandsFilterInput"
                  v-model="overdraft.brandsFilter"
                  :items="overdraft.brands"
                />
                <v-autocomplete
                  label="Exclusive for Game"
                  item-text="name"
                  item-value="game_id"
                  hide-details
                  class="col-6 pr-0"
                  clearable
                  v-model="overdraft.form.game_id_exclusive"
                  :items="filteredBonusGames"
                />
              </v-row>
              <v-row justify="center" class="px-0 mx-0">
                <v-autocomplete
                  label="Exclusive for Brand"
                  hide-details
                  clearable
                  class="col-6 pl-0"
                  v-model="overdraft.form.brand_exclusive"
                  :items="providerBrandsAliases"
                />
                <v-autocomplete
                  label="Exclusive for System"
                  hide-details
                  clearable
                  class="col-6 pr-0"
                  v-model="overdraft.form.system_exclusive"
                  :items="providerSystemsAliases"
                />
              </v-row>
            </v-form>
          </v-tab-item>
          <v-tab-item
            v-if="$store.state.auth.checkAccess({key: 'manual_transaction', value: 'sport_bonus'})"
            id="mt-sport_bonus"
          >
            <v-form
              ref="mt-form-sport_bonus"
              v-model="sport_bonus.valid"
              class="mt-4"
            >
              <v-row class="px-0 mx-0">

                <v-combobox
                  label="Sport Bonus Name"
                  :rules="[v => !!v || 'Sport Bonus Name is required']"
                  v-model="sport_bonus.form.name"
                  :items="sport_bonus.name[account.language || 'EN'] || sport_bonus.name['EN']">
                </v-combobox>

                <v-switch
                  style="width: 105px;"
                  class="switch-deleted mt-4 ml-4"
                  v-model="sport_bonus.internal"
                  :label="sport_bonus.internal ? 'Internal' : 'External'"
                ></v-switch>
              </v-row>

              <v-row v-if="!sport_bonus.internal" justify="center" class="px-0 mx-0">

                <v-select
                  label="Sport Bonus Template"
                  :rules="[v => !!v || 'Sport Bonus Template is required']"
                  v-model="sport_bonus.form.sport_bonus_id"
                  @change="updateSportBonusName"
                  :items="sport_bonus.templates"
                />

                <v-select
                  label="Status"
                  :rules="[v => !!v || 'Status is required']"
                  v-model="sport_bonus.form.status"
                  :items="sport_bonus.statuses"
                  class="col-3"
                />

                <v-text-field
                  v-if="!sport_bonus.internal"
                  required
                  label="Amount"
                  type="number"
                  :rules="[v => !!v || 'Amount is required']"
                  v-model="sport_bonus.form.amount"
                  :suffix="account.currency || ''"
                  hide-details
                  class="col-4"
                />

              </v-row>
              <template v-if="sport_bonus.internal">
                <v-row justify="center" class="px-0 mx-0">
                  <v-select
                    label="Rollover Type"
                    :rules="[v => !!v || 'Rollover Type is required']"
                    v-model="sport_bonus.form.rollover_type"
                    :items="sport_bonus.rollover_type">
                  </v-select>

                  <v-checkbox
                    label="Sticky bonus"
                    v-model="sport_bonus.form.sticky"
                    hide-details
                    :true-value="1"
                    :false-value="0"
                    class="ml-3 mt-0 pt-5"
                  />
                </v-row>

                <v-select
                  label="Type"
                  :rules="[v => !!v || 'Type is required']"
                  v-model="sport_bonus.form.bonus_type"
                  :items="sport_bonus.bonus_type">
                </v-select>

                <v-select
                  label="Release Type"
                  :rules="[v => !!v || 'Release Type is required']"
                  v-model="sport_bonus.form.release_type"
                  :items="sport_bonus.release_type">
                </v-select>

                <v-row justify="center">
                  <v-text-field
                    required
                    label="Wager"
                    type="number"
                    class="col-2"
                    :rules="[v => !!v || 'Wager is required']"
                    v-model="sport_bonus.form.wager"
                  ></v-text-field>

                  <v-select
                    label="Status"
                    :rules="[v => !!v || 'Status is required']"
                    v-model="sport_bonus.form.status"
                    :items="sport_bonus.statuses"
                    class="col-3"
                  ></v-select>

                  <date-picker
                    v-model="sport_bonus.form.expireDate"
                    label="Expire"
                    class="col-6 pa-0 px-3"
                    :show-time="true"
                    :time-value="sport_bonus.form.expireTime"
                    :check-validation="true"
                    @time-change="handleExpireTimeChange('sport_bonus', $event)"
                  />
                </v-row>
                <v-row>
                  <v-text-field
                    required
                    label="Deposit Amount %"
                    type="number"
                    v-model="sport_bonus.form.deposit_amount_percent"
                    hide-details
                    class="col-4"
                  ></v-text-field>
                  <v-spacer></v-spacer>
                  <v-text-field
                    required
                    label="Max Release"
                    type="number"
                    v-model="sport_bonus.form.max_release"
                    hide-details
                    class="col-4"
                  ></v-text-field>
                  <v-spacer></v-spacer>
                  <v-text-field
                    required
                    label="Amount"
                    type="number"
                    :rules="[v => !!v || 'Amount is required']"
                    v-model="sport_bonus.form.amount"
                    :suffix="account.currency || ''"
                    hide-details
                    class="col-4"
                  ></v-text-field>
                </v-row>

                <v-row justify="center">
                  <v-text-field
                    required
                    label="Min Odds"
                    type="number"
                    class="col-3"
                    v-model="sport_bonus.form.min_odds"
                    hide-details
                  />
                  <v-text-field
                    required
                    label="Bet Limits: Min"
                    type="number"
                    class="col-3"
                    v-model="sport_bonus.form.bet_limits_min"
                    hide-details
                  />

                  <v-text-field
                    required
                    label="Bet Limits: Max"
                    type="number"
                    class="col-3"
                    v-model="sport_bonus.form.bet_limits_max"
                    hide-details
                  />
                  <v-text-field
                    required
                    label="Min Games"
                    type="number"
                    class="col-3"
                    v-model="sport_bonus.form.min_games"
                    hide-details
                  />

                </v-row>

              </template>
              <v-divider class="mt-2" />

              <v-row class="px-0 mx-0 flex-wrap">
                <v-col cols="12" class="px-0">
                  <v-label>
                    Additional Requirements
                  </v-label>
                  <v-btn-toggle
                    v-model="sport_bonus.form.additional_requirements"
                    class="mt-1"
                    multiple
                    borderless
                  >
                    <v-btn
                      v-for="(label, key) in additionalRequirementOptions"
                      :key="key"
                      :value="key"
                      small
                      v-text="label"
                    />
                  </v-btn-toggle>
                </v-col>
              </v-row>
            </v-form>
          </v-tab-item>
          <v-tab-item
            v-if="$store.state.auth.checkAccess({key: 'manual_transaction', value: 'freespins'})"
            id="mt-freespins"
          >
            <v-form
              ref="mt-form-freespins"
              v-model="freespins.valid"
              class="mt-4"
            >
              <v-row justify="center" class="px-0 mx-0">
                <v-select
                  label="Rollover Type"
                  :rules="[v => !!v || 'Rollover Type is required']"
                  v-model="freespins.form.rollover_type"
                  :items="bonus.rollover_type">
                </v-select>

                <v-checkbox
                  label="Sticky bonus"
                  v-model="freespins.form.sticky"
                  hide-details
                  :true-value="1"
                  :false-value="0"
                  class="ml-3 mt-0 pt-5"
                />
              </v-row>
              <v-row class="">
                <v-combobox
                  multiple
                  label="Brands (filter)"
                  auto-select-first
                  :search-input.sync="freespins.brandsFilterInput"
                  @input="freespinsClearBrandFilter"
                  v-model="freespins.brandsFilter"
                  class="col-6"
                  :items="freespins.brands">
                </v-combobox>
                <v-spacer />
                <v-autocomplete
                  label="Game"
                  item-text="name"
                  item-value="game_id"
                  clearable
                  v-model="freespins.form.game_id"
                  :items="filteredFreespinsGames"
                  class="col-6"
                >
                  <template slot="selection" slot-scope="{ item }">
                    <div class="d-flex">
                      <span v-html="item.name" />
                      &nbsp;
                      <small>({{ item.system_name }} {{ item.game_id }})</small>
                    </div>
                  </template>
                  <template slot="item" slot-scope="{ item }">
                    <div style="width: 100%">
                      <span v-html="item.name"></span>
                      <small class="float-right">({{ item.system_name }} {{ item.game_id }})</small>
                    </div>
                  </template>
                </v-autocomplete>
              </v-row>

              <v-row justify="center">
                <v-text-field
                  required
                  label="Wager"
                  type="number"
                  class="col-2"
                  :rules="[v => !!v || 'Wager is required']"
                  v-model="freespins.form.wager"
                  hide-details
                ></v-text-field>

                <v-select
                  label="Status"
                  :rules="[v => !!v || 'Status is required']"
                  v-model="freespins.form.status"
                  :items="bonus.statuses"
                  hide-details
                  class="col-3"
                ></v-select>

                <date-picker
                  v-model="freespins.form.expireDate"
                  label="Expire"
                  class="col-6 pa-0 px-3"
                  :show-time="true"
                  :time-value="freespins.form.expireTime"
                  :check-validation="true"
                  @time-change="handleExpireTimeChange('freespins', $event)"
                />
              </v-row>

              <v-row :class="{'justify-center': freespins.form.amount_by_day?.length}">
                <v-text-field
                  required
                  label="Max FS Win"
                  type="number"
                  v-model="freespins.form.max_freespin_win"
                  hide-details
                  class="col-4"
                ></v-text-field>
                <v-spacer v-if="!freespins.form.amount_by_day?.length"></v-spacer>
                <v-text-field
                  required
                  label="Max Release"
                  type="number"
                  v-model="freespins.form.max_release"
                  hide-details
                  class="col-4"
                ></v-text-field>
                <v-spacer v-if="!freespins.form.amount_by_day?.length"></v-spacer>
                <v-text-field
                  v-if="!freespins.form.amount_by_day?.length"
                  required
                  label="Amount"
                  type="number"
                  :rules="[v => !!v || 'Amount is required']"
                  v-model="freespins.form.amount"
                  hide-details
                  class="col-4"
                >
                  <template #append-outer>
                    <v-btn
                      icon
                      title="Switch to a multiple-day schedule"
                      @click="freespins.form.amount_by_day?.push(0)"
                    >
                      <v-icon>mdi-vector-square-plus</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-row>
              <v-row v-if="freespins.form.amount_by_day?.length" class="px-3">
                <fieldset
                  class="pb-0 col-12 rounded-8"
                >
                  <legend class="px-3" style="margin-bottom: -10px;">
                    Freespin amount by day
                    <v-btn
                      icon
                      color="primary"
                      title="Add day"
                      @click="freespins.form.amount_by_day?.push(0)"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      color="error"
                      title="Remove last day"
                      :disabled="freespins.form.amount_by_day?.length === 1"
                      @click="freespins.form.amount_by_day?.pop()"
                    >
                      <v-icon>mdi-minus</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      color="error"
                      title="Return to single-use amount"
                      @click="freespins.form.amount_by_day = []"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>

                  </legend>
                  <v-row>
                    <v-col
                      v-for="(_, i) in freespins.form?.amount_by_day"
                      cols="2"
                      class="pt-0"
                      :key="i"
                    >
                      <v-text-field
                        v-model.number="freespins.form?.amount_by_day[i]"
                        type="number"
                        min="0"
                        :label="`Day ${i + 1}`"
                        hide-details
                      />
                    </v-col>
                    <v-col cols="2">
                    </v-col>

                  </v-row>
                </fieldset>
              </v-row>
              <v-row justify="center">
                <v-select
                  v-if="isPredefinedFreespinValue"
                  v-model="freespins.form.freespin_value"
                  class="col-3"
                  :items="selectedFreespinGame.freespin_value"
                  label="Freespin value"
                />
                <v-text-field
                  v-if="isManualFreespinValue"
                  v-model.number="freespins.form.freespin_value"
                  class="col-3"
                  type="number"
                  label="Freespin value"
                />
                <v-text-field
                  required
                  label="Bet Limit: Min"
                  type="number"
                  class="col-3"
                  v-model="freespins.form.bet_limits_min"
                  hide-details
                />

                <v-text-field
                  required
                  label="Bet Limit: Max"
                  type="number"
                  class="col-3"
                  v-model="freespins.form.bet_limits_max"
                  hide-details
                />

                <v-text-field
                  label="Comment"
                  v-model="freespins.form.comment"
                  class="col-3"
                  hide-details
                />

              </v-row>

              <v-divider class="mt-2" />

              <v-row class="px-0 mx-0 flex-wrap">
                <v-col cols="12" class="px-0">
                  <v-label>
                    Additional Requirements
                  </v-label>
                  <v-btn-toggle
                    v-model="freespins.form.additional_requirements"
                    class="mt-1"
                    multiple
                    borderless
                  >
                    <v-btn
                      v-for="(label, key) in additionalRequirementOptions"
                      :key="key"
                      :value="key"
                      small
                      v-text="label"
                    />
                  </v-btn-toggle>
                </v-col>
              </v-row>

              <v-divider class="mb-3 mt-2" />

              <v-label>Freespin win:</v-label>
              <v-row justify="center" class="px-0 mx-0 mb-1">
                <v-autocomplete
                  label="Exclusive for Brand"
                  clearable
                  hide-details
                  v-model="freespins.form.brand_exclusive"
                  :items="providerBrandsAliases"
                />
                <v-spacer />
                <v-autocomplete
                  label="Exclusive for System"
                  clearable
                  hide-details
                  v-model="freespins.form.system_exclusive"
                  :items="providerSystemsAliases"
                />
                <v-spacer />
                <v-autocomplete
                  label="Exclusive for Game"
                  item-text="name"
                  item-value="game_id"
                  hide-details
                  clearable
                  v-model="freespins.form.game_id_exclusive"
                  :items="filteredBonusGames"
                />
                <!--                <v-checkbox-->
                <!--                  label="Exclusive Game"-->
                <!--                  v-model="freespins.form.game_exclusive"-->
                <!--                  hide-details-->
                <!--                  true-value="1"-->
                <!--                  false-value="0"-->
                <!--                  class="mr-4 mt-0"-->
                <!--                ></v-checkbox>-->
                <!--                <v-checkbox-->
                <!--                  label="Exclusive Brand"-->
                <!--                  v-model="freespins.form.brand_exclusive"-->
                <!--                  hide-details-->
                <!--                  true-value="1"-->
                <!--                  false-value="0"-->
                <!--                  class="ml-4 mt-0"-->
                <!--                ></v-checkbox>-->
              </v-row>
            </v-form>
          </v-tab-item>
          <v-tab-item
            v-if="$store.state.auth.checkAccess({key: 'manual_transaction', value: 'bonus_template'})"
            id="mt-bonus_template"
          >
            <v-form
              ref="mt-form-bonus_template"
              v-model="bonus_template.valid"
            >
              <v-row class="mx-0">
                <v-autocomplete
                  label="Bonus Template"
                  :rules="[v => !!v || 'Template is required']"
                  v-model="bonus_template.form"
                  :items="bonus_template.items"
                  item-text="name"
                  return-object
                  auto-select-first
                  clearable
                  class="pb-0"
                />

                <v-text-field
                  v-if="bonus_template.form.deposit_amount_required"
                  required
                  label="Deposit Amount"
                  type="number"
                  :rules="[v => !!v || 'Deposit amount is required']"
                  v-model="bonus_template.form.deposit_amount"
                  :suffix="account.currency"
                  class="col-4 pb-0"
                />
              </v-row>
            </v-form>
          </v-tab-item>
        </v-tabs-items>

      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn
          color="error"
          text
          @click="$store.state.manual_transaction.dialog = false"
        >
          Cancel
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          :loading="loading"
          :disabled="loading"
          @click="handler"
        >
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style>
  .mt-tab-menu {
    zoom: 0.90;
  }
</style>

<script>

  import { uniq, max, filter, cloneDeep, map, get, find, round } from 'lodash'
  import moment from 'moment'
  import { API } from '@/utils/api'
  import { mask } from 'vue-the-mask'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'

  export default {
    directives: {
      mask,
    },
    components: {
      DatePicker
    },
    props: [ 'text', 'size', 'success', 'error', 'finally' ],

    data: () => ({
      balance: {
        valid: null,
        message: 'Increase/decrease account balance',
        initForm: {
          type: 'manual_transaction'
        },
        form: {},
        type: [
          { text: 'Cash Bonus', value: 'cash_bonus' },
          { text: 'Correction', value: 'correction' },
          { text: 'Manual Transaction', value: 'manual_transaction' },
        ],
        name: {
          cash_bonus: [ { text: 'Cash Bonus', value: 'cash_bonus' } ],
          correction: [ { text: 'Cash', value: 'cash' } ],
          manual_transaction: [],
        },

        isLoadingManualTransactionOptions: false,
      },
      bonus_template: {
        valid: null,
        loading: false,
        items: [],
        message: 'Apply bonus template',
        initForm: {},
        form: {},
      },

      refund: {
        valid: null,
        message: 'Create pending withdraw',
        initForm: {
          paymethod: null
        },
        form: {},
        paymethod: [
          { text: 'Manual Withdraw', value: 'manual_transaction' },
          { text: 'CreditCard', value: 'creditcard' },
          { text: 'Skrill', value: 'skrill' },
          { text: 'Mifinity PAB', value: 'mifinity_pab' },
          { text: 'Noda', value: 'noda' },
          { text: 'Skrill', value: 'skrill' },
          { text: 'RapidTransfer', value: 'skrill_RapidTransfer' },
          { text: 'Bitpace', value: 'bitpace' },
          { text: 'Muchbetter', value: 'muchbetter' },
          { text: 'Coinspaid (btc)', value: 'coinspaid_btc' },
          { text: 'Coinspaid (ltc)', value: 'coinspaid_ltc' },
          { text: 'Coinspaid (eth)', value: 'coinspaid_eth' },
          { text: 'Coinspaid (usdt)', value: 'coinspaid_usdt' },
          { text: 'Coinspaid (doge)', value: 'coinspaid_doge' },
          { text: 'Coinspaid (xrp)', value: 'coinspaid_xrp' },
          { text: 'Coinspaid (trx)', value: 'coinspaid_trx' },
        ]
      },

      respin: {
        valid: null,
        benefitListLoading: false,
        message: 'Create respin',
        initForm: {
          benefit_id: null,
          types: [],
          status: 'new',
          name: '',
          expireDate: moment().format('YYYY-MM-DD'),
          expireTime: '00:00:00',
          additional_requirements: [],
        },
        form: {},
        statuses: [
          { text: 'New', value: 'new' },
          { text: 'Active', value: 'active' },

        ],
        chipCount: 1,
        type_list: [
          { text: 'Wheel', value: 'wheel' },
          { text: 'Lucky Box', value: 'luckybox' },
        ],
        benefit_list: [],
      },
      bonus: {
        valid: null,
        message: 'Create bonus',
        initForm: {
          name: '',
          subtype: '',
          rollover_type: 'bonus',
          status: 'new',
          wager: 30,
          deposit_amount_percent: 0,
          deposit_amount: 0,
          expireDate: moment().format('YYYY-MM-DD'),
          expireTime: '00:00:00',
          additional_requirements: [],
        },
        form: {},
        rollover_type: [
          { text: 'Bonus', value: 'bonus' },
          { text: 'Cash', value: 'cash' }
        ],
        brands: [],
        brandsFilter: [],
        brandsFilterInput: '',
        games: [],
        statuses: [
          { text: 'New', value: 'new' },
          { text: 'Active', value: 'active' },

        ],
        name: {
          'RU': [
            'Бонус за регистрацию',
            'Бездепозитный бонус',
            'Бонус за лояльность',
            'Бонус от VIP менеджера',
            '10% Бонус на депозит',
            '20% Бонус на депозит',
            '30% Бонус на депозит',
            '40% Бонус на депозит',
            '50% Бонус на депозит',
            '60% Бонус на депозит',
            '70% Бонус на депозит',
            '80% Бонус на депозит',
            '90% Бонус на депозит',
            '100% Бонус на депозит',
            '120% Бонус на депозит',
            '150% Бонус на депозит',
            '200% Бонус на депозит',
            '10% Кэш Бонус',
            '10% Кэшбэк',
            '15% Кэшбэк',
            'Приз за -е место в турнире',
            'Еженедельный бонус',
            'Бонус на выходные',
            'Фриспины за регистрацию',
            'Еженедельные фриспины',
            'Фриспины на выходные'
          ],
          'PL': [
            'Bonus za rejestracje',
            'Bonus powitalny / Bonus bezdepozytowy',
            'Bonus Lojalnościowy',
            'VIP bonus',
            '10% Bonus na depozyt',
            '20% Bonus na depozyt',
            '30% Bonus na depozyt',
            '40% Bonus na depozyt',
            '50% Bonus na depozyt',
            '60% Bonus na depozyt',
            '70% Bonus na depozyt',
            '80% Bonus na depozyt',
            '90% Bonus na depozyt',
            '100% Bonus na depozyt',
            '120% Bonus na depozyt',
            '150% Bonus na depozyt',
            '200% Bonus na depozyt',
            '10% Bonus gotówkowy',
            '10% Cashback',
            '15% Cashback',
            'Weekly Reload',
            'Weekend Reload',
            'Registration FS',
            'Weekend FS',
            'Weekly FS'
          ],
          'EN': [
            'Registration bonus',
            'No deposit bonus',
            'Loyality bonus',
            'VIP bonus',
            '10% bonus',
            '20% bonus',
            '30% bonus',
            '40% bonus',
            '50% bonus',
            '60% bonus',
            '70% bonus',
            '80% bonus',
            '90% bonus',
            '100% bonus',
            '120% bonus',
            '150% bonus',
            '200% bonus',
            '10% cash bonus',
            '10% cashback ',
            '15% cashback',
            'place in tournament',
            'Weekly Reload',
            'Weekend Reload',
            'Registration FS',
            'Weekend FS',
            'Weekly FS'
          ]
        },
      },

      overdraft: {
        valid: null,
        message: 'Create bonus',
        initForm: {
          name: '',
          status: 'new',
          expireDate: moment().format('YYYY-MM-DD'),
          expireTime: '00:00:00',
          additional_requirements: [],
        },
        form: {},
        brands: [],
        brandsFilter: [],
        brandsFilterInput: '',
        games: [],
        statuses: [
          { text: 'New', value: 'new' },
          { text: 'Active', value: 'active' },

        ],
        name: {}
      },

      sport_bonus: {
        valid: null,
        message: 'Create sport bonus',
        internal: true,
        templates: [],
        initForm: {
          name: '',
          betby_template_id: null,
          rollover_type: 'bonus',
          release_type: 'bonus',
          bonus_type: 'STD',
          status: 'new',
          wager: 35,
          deposit_amount_percent: 0,
          deposit_amount: 0,
          expireDate: moment().format('YYYY-MM-DD'),
          expireTime: '00:00:00',
          additional_requirements: [],
        },
        form: {},
        rollover_type: [
          { text: 'Bonus', value: 'bonus' },
          { text: 'Cash', value: 'cash' }
        ],
        bonus_type: [
          { text: 'Bonus money', value: 'STD' },
          { text: 'Free bet', value: 'FB' },
          { text: 'No Risk Bet', value: 'NRB' },
          { text: 'Free money bet', value: 'FMB' }
        ],
        release_type: [
          { text: 'Bonus', value: 'bonus' },
          { text: 'Cash', value: 'cash' }
        ],
        statuses: [
          { text: 'New', value: 'new' },
          { text: 'Active', value: 'active' },

        ],
        name: {
          'RU': [],
          'PL': [],
          'EN': []
        }
      },

      freespins: {
        message: 'Create freespin bonus',
        valid: null,
        initForm: {
          rollover_type: 'bonus',
          status: 'new',
          wager: 50,
          expireDate: moment().format('YYYY-MM-DD'),
          expireTime: '00:00:00',
          freespin_value: null,
          additional_requirements: [],
          amount_by_day: [],
        },
        form: {},
        brands: [],
        brandsFilter: [],
        brandsFilterInput: '',
        games: [],
      },
      // dialog: null,
      state: null,
      bonusTypeModel: null,
      loading: false,
      transaction: {},
      additionalRequirementOptions: {
        'kyc.verified': 'KYC Verification',
        'kyc.primary_verification': 'KYC Automatic Verification',
        'account.data.verified.email': 'Email Verification',
        'account.data.verified.phone': 'Phone Number Verification',
      },
    }),

    mounted () {
      if (!this.$store.state.auth.checkAccess({ key: 'manual_transaction', value: 'bonus' })) {
        this.balance.type = filter(this.balance.type, (o) => o.value != 'cash_bonus')
      }
      if (this.$store.state.auth.checkAccess({ key: 'manual_transaction', value: 'cash_only' })) {
        this.balance.type = [ { text: 'Cash', value: 'cash' } ]
        this.balance.name = { cash: [ { text: 'Cash', value: 'cash' } ] }
        this.balance.initForm.type = 'cash'
        this.balance.initForm.name = { text: 'Cash', value: 'cash' }
      }

      this.reset()
    },

    computed: {
      entity_id: function () {
        let entity = this.$store.state.auth.getEntityByLogin(this.account.login)
        return entity.entity_id
      },
      account () {
        return this.$store.state.manual_transaction.account
      },
      isBonusIssuanceAllowed () {
        return this.account.is_bonus_allowed
      },
      balanceTypeOptions () {
        return this.isBonusIssuanceAllowed ? this.balance.type : this.balance.type.filter(option => option.value !== 'cash_bonus')
      },
      availableTabs () {
        return [
          { key: 'balance', href: 'mt-balance', label: 'Balance' },
          { key: 'refund', href: 'mt-refund', label: 'Refund' },
          ...this.isBonusIssuanceAllowed ? [
            { key: 'bonus', href: 'mt-bonus', label: 'Bonus' },
            { key: 'overdraft', href: 'mt-overdraft', label: 'Overdraft' },
            { key: 'sport_bonus', href: 'mt-sport_bonus', label: 'Sport Bonus' },
            { key: 'freespins', href: 'mt-freespins', label: 'Freespins' },
            { key: 'respin', href: 'mt-respin', label: 'Respin' },
          ] : [],
          { key: 'bonus_template', href: 'mt-bonus_template', label: 'Template' },
        ].filter(tab =>
          this.$store.state.auth.checkAccess({
            key: 'manual_transaction',
            value: tab.key
          })
        )
      },
      freespinsGameExclusiveComputed: {
        get () {
          const gameId = this.freespins.form.game_id_exclusive
          const game = this.filteredBonusGames.find(g => g.game_id === gameId)
          return game ? game.name : ''
        },
        set (val) {
          const game = this.filteredBonusGames.find(g => g.name === val)
          this.freespins.form.game_id_exclusive = game ? game.game_id : null
        }
      },
      freespinsGameComputed: {
        get () {
          const gameId = this.freespins.form.game_id
          const game = this.filteredFreespinsGames.find(g => g.game_id === gameId)
          return game ? game.name : ''
        },
        set (val) {
          const game = this.filteredFreespinsGames.find(g => g.name === val)
          this.freespins.form.game_id = game ? game.game_id : null
        }
      },
      expireDays () {
        return (this.account.bonus_params || { expire_days: 10 }).expire_days
      },
      filteredBonusGames: function () {
        return this.bonus.games.filter(g => {
          return this.bonus.brandsFilter.length < 1 || (this.bonus.brandsFilter.includes(g.brand.alias))
        })
      },
      filteredFreespinsGames: function () {
        if (!this.freespins.brandsFilter.length) {
          return this.freespins.games
        }

        return this.freespins.games.filter(g => {
          return this.freespins.brandsFilter.includes(g.brand.alias)
        })
      },
      selectedFreespinGame () {
        if (this.freespins.form.game_id) {
          return this.filteredFreespinsGames.find(game => game.game_id === this.freespins.form.game_id)
        }
      },
      isManualFreespinValue () {
        return typeof this.selectedFreespinGame?.freespin_value === 'boolean' && this.selectedFreespinGame.freespin_value
      },
      isPredefinedFreespinValue () {
        return Array.isArray(this.selectedFreespinGame?.freespin_value) && this.selectedFreespinGame.freespin_value.length
      },
      providerBrandsAliases: function () {
        return map(this.bonus.games, (i) => [ get(i, 'system_alias'), get(i, 'brand_alias') ].join('.'))
      },
      providerSystemsAliases: function () {
        return map(this.bonus.games, 'system_alias')
      }
    },

    watch: {
      'respin.form.types': {
        handler () {
          if(this.$store.state.manual_transaction.dialog) {
            this.loadBenefitList()
          }
        },
      },
      'bonus.form.deposit_amount_percent': function (val) {
        this.bonus.form.deposit_amount = round(((this.bonus.form.amount || 0) / this.bonus.form.deposit_amount_percent) * 100)
      },
      'bonus.form.amount': function (val) {
        this.bonus.form.deposit_amount = round(((this.bonus.form.amount || 0) / this.bonus.form.deposit_amount_percent) * 100)
      },
      'sport_bonus.form.deposit_amount_percent': function (val) {
        this.sport_bonus.form.deposit_amount = round(((this.sport_bonus.form.amount || 0) / this.sport_bonus.form.deposit_amount_percent) * 100)
      },
      'sport_bonus.form.amount': function (val) {
        this.sport_bonus.form.deposit_amount = round(((this.sport_bonus.form.amount || 0) / this.sport_bonus.form.deposit_amount_percent) * 100)
      },
      '$store.state.manual_transaction.dialog': function (val) {

        if (val) {
          API.call('/$v/game/list.json', {
            with_excludes: true,
          }, this.account).then(resp => {
            this.bonus.games = resp.data
            this.bonus.brands = uniq(map(resp.data, 'brand.alias'))
            this.freespins.games = filter(resp.data, (g) => g.allow_freespins > 0)
            this.freespins.brands = uniq(map(this.freespins.games, 'brand.alias'))
          }).catch(e => {
          })

          API.call('/$v/bonus_template/sport_bonus_list.json', { deleted: [ 0 ] }, this.account).then(resp => {
            this.sport_bonus.templates = map(resp.data, o => ({ text: o.name, value: o.sport_bonus_id }))
          }).catch(() => {
          })

          this.loadBonusTemplateList()

          if (this.$store.state.manual_transaction.tabType) {
            this.setTabAndFormData()
          }

          this.loadManualTransactionOptions()
        } else {
          this.reset()
          this.$store.dispatch('manual_transaction/close')
        }
      }
    },

    methods: {
      max,
      bonusClearBrandFilter () {
        this.bonus.brandsFilterInput = ''
      },
      freespinsClearBrandFilter () {
        this.freespins.brandsFilterInput = ''
      },

      updateSportBonusName (ev) {
        if (!this.sport_bonus.form.name) {
          this.sport_bonus.form.name = find(this.sport_bonus.templates, { value: ev }).text
        }
      },

      async loadBenefitList () {
        this.respin.benefitListLoading = true

        try {
           const resp = await API.call('/bonus_tools/dictionary/benefit_list.json', {
            types: this.respin.form.types,
             enabled: true
          }, null, this.entity_id)

          const benefits = get(resp, 'data', [])
          this.respin.benefit_list = this.respin.form.types.length > 0
            ? benefits.map(benefit => ({
                ...benefit,
                name: benefit.text,
                text: `${benefit.text} | ${benefit.alias} | ${benefit.value}`
              }))
            : []
          return resp.data

        } finally {
          this.respin.benefitListLoading = false

        }
      },

      loadBonusTemplateList () {
        if (!this.$store.state.auth.checkAccess({
          key: 'bonus_template',
          value: true
        }) && !this.$store.state.auth.checkAccess({ key: 'manual_transaction', value: 'bonus_template' })) {
          return
        }

        this.bonus_template.loading = true
        return API.call('/$v/bonus_template/list.json', { deleted: 0 }, this.account).then(resp => {
          this.bonus_template.items = resp.data
        }).finally(() => {
          this.bonus_template.loading = false
        })
      },

      reset: function () {
        this.bonusTypeModel = 'balance'

        this.bonus.initForm.expireDate = moment().utc().add(this.expireDays, 'days').format('YYYY-MM-DD')
        this.overdraft.initForm.expireDate = moment().utc().add(this.expireDays, 'days').format('YYYY-MM-DD')
        this.sport_bonus.initForm.expireDate = moment().utc().add(this.expireDays, 'days').format('YYYY-MM-DD')
        this.respin.initForm.expireDate = moment().utc().add(this.expireDays, 'days').format('YYYY-MM-DD')
        this.freespins.initForm.expireDate = moment().utc().add(this.expireDays, 'days').format('YYYY-MM-DD')

        this.balance.form = cloneDeep(this.balance.initForm)
        this.refund.form = cloneDeep(this.refund.initForm)
        this.bonus.form = cloneDeep(this.bonus.initForm)
        this.overdraft.form = cloneDeep(this.overdraft.initForm)
        this.sport_bonus.form = cloneDeep(this.sport_bonus.initForm)
        this.respin.form = cloneDeep(this.respin.initForm)

        setTimeout(() => {
          this.sport_bonus.internal = true
        }, 2000)
        this.freespins.form = cloneDeep(this.freespins.initForm)
      },

      handleExpireTimeChange (formType, time) {
        this[formType].form.expireTime = time ?  moment(time || '00:00:00', 'HH:mm:ss').format('HH:mm:ss') : '00:00:00'
      },

      setTabAndFormData () {
        const tabType = this.$store.state.manual_transaction.tabType
        const formData = this.$store.state.manual_transaction.formData

        if (tabType) {
          if (tabType.startsWith('mt-')) {
            this.bonusTypeModel = tabType
          } else {
            this.bonusTypeModel = `mt-${tabType}`
          }
        }

        if (!this[tabType]) {
          this.$store.commit('manual_transaction/clear_tab_data')
          return
        }

        if (formData && Object.keys(formData).length) {
          this[tabType].form = {
            ...this[tabType].form,
            ...formData
          }
        }

        this.$store.commit('manual_transaction/clear_tab_data')
      },

      handler: async function () {
        let action = this.bonusTypeModel.replace('mt-', '')

        this.$refs['mt-form-' + action].validate()

        if (this[action].valid && await this.$root.$confirm('Confirm', this[action].message, { width: 470 })) {
          this.loading = true

          let bonusName = this[action].form.name
          if (action === 'respin' && this.respin.form.benefit_id) {
            bonusName = this.respin.benefit_list.find((benefit) => benefit.value === this.respin.form.benefit_id)?.name
          }

          const formData = { ...this[action].form }
          if (action === 'bonus' || action === 'respin') {
            formData.name = bonusName
          }

          API.call('/$v/account/finance/manual_transaction.json', {
            login: this.account.login,
            account_id: this.account.account_id,
            currency: this.account.currency,
            action,
            game_name: get(find(get(this[action], 'games', []), (g) => g.game_id == this[action].form.game_id), 'name'),
            ...formData
          }, this.account).then(resp => {

            this.$store.dispatch('account/get_balance', {
              value: this.account.login,
              account_id: this.account.account_id,
              login: this.account.login
            }).then(resp => {
              this.$store.commit('account/balance_refresh', resp.data)
            })

            this.$store.dispatch('account/loadBonuses', this.account)

            this.$store.state.manual_transaction.dialog = false

            if (typeof this.success === 'function') {
              this.success()
            }

          }).catch(e => {
            if (typeof this.error === 'function') {
              this.error()
            }

          }).finally(() => {
            this.loading = false

            if (typeof this.finally === 'function') {
              this.finally()
            }
          })
        }

        // this.dialog = false
      },

      loadManualTransactionOptions() {
        this.balance.isLoadingManualTransactionOptions = true
        this.balance.name.manual_transaction = []

        return API.call('/$v/paymethod/manual_transaction_options.json', {}, null, this.entity_id)
          .then(r => {
            this.balance.name.manual_transaction = r.data.map(option => ({
              text: option.title ?? option.name,
              value: option.name,
            }))
          })
          .finally(() => {
            this.balance.isLoadingManualTransactionOptions = false
          })
      }
    }

  }
</script>
